"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderUpsellButton = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
exports.HeaderUpsellButton = function (_a) {
    var onUpsellButtonClick = _a.onUpsellButtonClick;
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement("button", { className: "gd-button-small gd-button-primary gd-upsell-button", onClick: onUpsellButtonClick },
        react_1.default.createElement("i", { className: "gd-icon-star" }),
        react_1.default.createElement("span", { className: "gd-upgrade-button-text" }, intl.formatMessage({ id: "gs.header.upsellButtonText" }))));
};
//# sourceMappingURL=HeaderUpsellButton.js.map